import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../pages/HomeView.vue'
import MealsView from '../pages/MealsView.vue'
import RecipesView from '../pages/RecipesView.vue'
import ShoppingListsView from '../pages/ShoppingListsView.vue'
import ShoppingListDetailView from '../pages/ShoppingListDetailView.vue'
import ShoppingItemsView from '../pages/ShoppingItemsView.vue'
import IngredientsView from '../pages/IngredientsView.vue'
import UserView from '../pages/UserView.vue'
import HelpView from '../pages/HelpView.vue'
import LoginView from '../pages/LoginView.vue'
import RegisterView from '../pages/RegisterView.vue'
import RecipeView from '../pages/RecipeView.vue'
import ForgotPasswordView from '../pages/ForgotPasswordView.vue'
import ResetPasswordView from '../pages/ResetPasswordView.vue'
import GroupsListView from '../pages/groups/GroupsListView.vue'
import CreateGroupView from '../pages/groups/CreateGroupView.vue'
import GroupDetailView from '../pages/groups/GroupDetailView.vue'
import EditGroupView from '../pages/groups/EditGroupView.vue'
import GroupMembersView from '../pages/groups/GroupMembersView.vue'
import AddMemberView from '../pages/groups/AddMemberView.vue'
import { authGuard } from './guards'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', component: HomeView, meta: { requiresAuth: true } },
  { path: '/meals', component: MealsView, meta: { requiresAuth: true } },
  { path: '/recipes', component: RecipesView, meta: { requiresAuth: true } },
  { path: '/recipes/:slug', component: RecipeView, meta: { requiresAuth: true } },
  { path: '/shopping-lists', component: ShoppingListsView, meta: { requiresAuth: true } },
  { path: '/shopping-lists/:id', component: ShoppingListDetailView, meta: { requiresAuth: true } },
  { path: '/shopping-items', component: ShoppingItemsView, meta: { requiresAuth: true } },
  { path: '/ingredients', component: IngredientsView, meta: { requiresAuth: true } },
  { path: '/user', component: UserView, meta: { requiresAuth: true } },
  { path: '/help', name: 'Help', component: HelpView, meta: { requiresAuth: true } },
  { path: '/login', component: LoginView },
  { path: '/register', component: RegisterView },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPasswordView },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPasswordView },

  // Group Routes
  { path: '/groups', name: 'GroupsList', component: GroupsListView, meta: { requiresAuth: true } },
  { path: '/groups/new', name: 'CreateGroup', component: CreateGroupView, meta: { requiresAuth: true } },
  { path: '/groups/:id', name: 'GroupDetail', component: GroupDetailView, meta: { requiresAuth: true }, props: true },
  { path: '/groups/:id/edit', name: 'EditGroup', component: EditGroupView, meta: { requiresAuth: true }, props: true },
  { path: '/groups/:id/members', name: 'GroupMembers', component: GroupMembersView, meta: { requiresAuth: true }, props: true },
  { path: '/groups/:id/members/add', name: 'AddMember', component: AddMemberView, meta: { requiresAuth: true }, props: true },

  // Catch-all: unknown paths redirect to /home (auth guard will send unauthenticated users to /login)
  { path: '/:pathMatch(.*)*', redirect: '/home' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(authGuard)

export default router
